<template>
  <div>
    <a-switch :checked="isActive" size="small" @change="handleSwitchStatus" />
    <div v-if="isActive">
      <a-modal :visible="visible" width="450px" :footer="null" @cancel="handleCloseModal">
        <div class="container__inactive">
          <img class="image__delete" :src="questionImage" alt="delete" />
          <h1 class="text__alert">¿Estás seguro de desactivar la cola {{ queue?.name }}?</h1>
        </div>
        <p class="text">Recuerda que se tomarán las siguientes acciones:</p>
        <ul>
          <li>Se desconectarán los canales asignados.</li>
          <li>Los tickets asociados a este canal se resolverán de manera automática</li>
          <li>Los usuarios asignados a esta cosa se desvincularán</li>
          <li>Las llamadas asociadas se finalizarán</li>
        </ul>

        <div class="button__disabled">
          <a-button style="width: 100%" class="footer__delete" type="primary" @click="changeStatus">
            Desactivar canal
          </a-button>
        </div>
      </a-modal>
    </div>
    <div v-else>
      <queues-editor-modal
        :key="queue.id + '-activate'"
        :value="modal"
        :isActive="false"
        :queue="queue"
        @update="handleUpdate"
        @onClose="modal = false"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, createVNode } from "vue";
import { InfoCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import QueuesEditorModal from "@/app/queues/components/modals/QueuesEditorModal.vue";
import { Modal } from "ant-design-vue";
import { mapQueue } from "@/app/queues/utils/helpers";
import EventBus from "@/app/shared/utils/eventBus";
import { QueuesEvent } from "@/app/queues/domain/events";
import questionImage from "@/app/common/assets/question-circle.png";
import { fetchValidateQueuesBots } from "@/app/entities/services";
export default defineComponent({
  components: {
    QueuesEditorModal,
  },
  props: {
    queue: { required: true, type: Object },
    validateBot: { required: false, type: Boolean },
  },
  data() {
    return {
      visible: false,
      modal: false,
    };
  },
  computed: {
    isActive() {
      return this.queue.status === 1 ? true : false;
    },
  },
  methods: {
    handleCloseModal() {
      this.visible = false;
    },
     async handleValidateQueuesBots() {
      try {
        if (this.queue?.id) {
          const response = await fetchValidateQueuesBots(this.queue?.id);
        }
      } catch (error) {
        if (error.status === 400) {
          const errorMessage = error?.getErrorMessage?.() || "";
          const regex = /([A-Za-z_]\w*):\s*([\s\S]*?)(?=(?:[A-Za-z_]\w*):|$)/gu;
          let match;
          const data = {};

          while ((match = regex.exec(errorMessage)) !== null) {
            const key = match[1];
            const value = match[2];
            data[key] = value;
          }

          // Ahora puedes acceder a cada valor
          const chatbot_total = Number(data.chatbot_total) || 0;
          const beexai_total = Number(data.beexai_total) || 0;
          const message = [
            chatbot_total > 0 && beexai_total > 0
            ? `Esta cola no puede ser inactivada porque está vinculada a ${chatbot_total} chatbot${chatbot_total > 1 ? "s" : ""} y ${beexai_total} bot${beexai_total > 1 ? "s AI" : " AI"} activos.`
            : chatbot_total > 0 
            ? `Esta cola no puede ser inactivada porque está vinculada a ${chatbot_total} chatbot${chatbot_total > 1 ? "s activos" : " activo"}.`
            : beexai_total > 0 
            ? `Esta cola no puede ser inactivada porque está vinculada a ${beexai_total} bot${beexai_total > 1 ? "s AI activos" : " AI activo"}.`
            : ""
            ].filter(Boolean).join(" ");

          const chatBot = data.chatbot ? data.chatbot.split(",").map(v => v.trim()) : [];
          const beexAI = data.beexai ? data.beexai.split(",").map(v => v.trim()) : [];
          await this.handleErrorModal(
            message,
            beexAI,
            chatBot
          );
        } else {
          this.$message.warning("Algo salió mal, por favor, vuelve a intentarlo.");
        }
        throw error;
      }
    },
    async handleSwitchStatus() {
      if (this.validateBot) {
        await this.handleValidateQueuesBots();
      }
      if (this.isActive) {
        if (this.queue.channels_customer.length > 0) {
          this.visible = true;
        } else {
          Modal.confirm({
            title: `¿Estás seguro de desactivar la cola ”${this.queue.name}”?`,
            icon: createVNode(QuestionCircleOutlined),
            content:
              "Los tickets y llamadas que se encuentren siendo atendidas por los usuarios asignados a esta cola se resolverán de manera automática.",
            onOk: () => this.changeStatus(),
            centered: true,
            okText: "Desactivar",
            cancelText: "Cancelar",
          });
        }
      } else {
        this.handleClick();
      }
    },
    async handleErrorModal(title, botIA, chatBot) {
      const text = botIA.length > 0 && chatBot.length > 0
          ? "Inactiva los chatbots y bots AI vinculados, o reemplaza la cola de transferencia en los chatbots o la cola seleccionada en los bots AI."
          : "Inactiva los bots AI vinculados o reemplaza la cola por otra en su configuración.";

      Modal.confirm({
        title: title,
        icon: createVNode(InfoCircleOutlined),
        content:  createVNode("div", { class: "inactive-bot-modal" }, [
                  createVNode("p", { class: "text-base font-medium mb-2" }, text),
                  // ChatBots
                  chatBot.length > 0
                    ? createVNode("div", {}, [
                        createVNode(
                          "span",
                          { class: "font-medium mb-1" },
                          "ChatBots vinculados"
                        ),
                        createVNode(
                          "ul",
                          { class: "list-disc list-inside text-sm text-gray-600" },
                          chatBot.map((c) => createVNode("li", { key: c }, c))
                        ),
                      ])
                    : null,
                  botIA.length > 0
                    ? createVNode("div", {}, [
                        // Bots AI
                        createVNode(
                          "span",
                          { class: "font-medium mb-1" },
                          "Bots AI vinculados"
                        ),
                        createVNode(
                          "ul",
                          { class: "list-disc list-inside text-sm text-gray-600 mb-2" },
                          botIA.map((bot) => createVNode("li", { key: bot }, bot))
                        ),

                        
                      ])
                    : null,
                ]),
                
        centered: true,
        okText: "Entendido",
        cancelButtonProps: { style: { display: "none" } },
      });
    },
    async changeStatus() {
      try {
        if (this.isActive) {
          await this.$store.dispatch("deactivateQueue", this.queue);
          this.$message.success(`Se ha desactivado el canal “${this.queue.name}” correctamente`);
        } else {
          await this.$store.dispatch("updateQueue", this.queue);
          this.$message.success(`Se ha activado el canal “${this.queue.name}” correctamente`);
        }
        this.handleUpdate();
        this.visible = false;
      } catch (error) {
        this.visible = false;
        this.$message.warning("Algo salió mal, por favor, vuelve a intentarlo.");
      }
    },
    async setQueueToStore() {
      const queue = mapQueue(this.queue);
      await this.$store.dispatch("setQueueProperties", queue);
    },
    async handleClick() {
      await this.setQueueToStore();
      this.modal = true;
      EventBus.$emit(QueuesEvent.QUEUE_MODAL_EDIT_OPENED);
    },
    handleUpdate() {
      this.$emit("update");
    },
  },
});
</script>

<style lang="sass" scoped>
.container__inactive
  text-align: center

.image__delete
  margin-bottom: 10px
.text__alert
  font-size: 16px
  font-weight: 600
.button__disabled
  margin-top: 10px
.text
  margin-bottom: 20px
:global(.font-medium .mb-1)
  font-weight: 600 !important
</style>
